var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[(_vm.isNolist)?_c('div',{staticClass:"box1"},[_c('img',{attrs:{"src":require("../assets/empty/ic_wuxingxi.png")}}),_c('p',{staticClass:"tip1"},[_vm._v(_vm._s(_vm.message))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }